export default class RequiredMap<K extends string, V> {
  #map = new Map<K, V>();

  public get(key: K): V {
    const value: V | undefined = this.#map.get(key);

    if (typeof value !== 'undefined') {
      return value;
    }

    throw new Error(`Could not find a value with key "${key}".`, {
      cause: this,
    });
  }

  public set(key: K, value: V): void {
    this.#map.set(key, value);
  }
}
